var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "nonzero",
    stroke: "current",
    d: "M4 5h16v12.063h-5.987L8.04 21v-3.937H4z"
  })));
}
export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Ctitle%3E09 Icons / General / CommentFilled%3C/title%3E %3Cg id='09-Icons-/-General-/-CommentFilled' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cpolygon id='Rectangle-Copy' fill='%23000000' fill-rule='nonzero' points='4 5 20 5 20 17.0634766 14.0131836 17.0634766 8.03930664 21 8.03930664 17.0634766 4 17.0634766' fill='current' stroke='current'%3E%3C/polygon%3E %3C/g%3E %3C/svg%3E";
export { SvgCommentIcon as ReactComponent };